import {Component} from 'react';
import PropTypes from 'prop-types';
import {emailRe} from '@deliveriesondemand/dod-regexes';

class EmailInput extends Component {
    static defaultProps = {
        placeholder: 'name@example.com',
        onChange: () => {}
    };

    static propTypes = {
        placeholder: PropTypes.string,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);
        const {value = ''} = props;
        this.state = {value};
    }

    get value() {
        const {refs} = this;
        return refs.input.value;
    }

    getErrors(label = '') {
        if (!this.value) {
            return [`${label} is empty`];
        } else if (!this.value.match(emailRe)) {
            return [`${label} is invalid`];
        }
        return [];
    }

    onChange() {
        const {props} = this;
        const {onChange} = props;
        let {value} = this;
        value = value.replace(' ', '');
        this.setState({value});
        onChange(value);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }

    render() {
        const {value} = this.state;
        return (
            <input
                ref="input"
                type="email"
                pattern={emailRe}
                {...this.props}
                onChange={this.onChange.bind(this)}
                value={value ? value : ''} />
        );
    }
}

export default EmailInput;
